import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { getFormattedValue } from "../../../../utils/previewValueFormatterUtils";
import { PreviewCardLayout } from "./PreviewCardLayout";

interface MemberCardProps {
  params: Record<string, string>;
  url: string;
}

export const MemberCard = ({ params, url }: MemberCardProps) => {
  const MEMBER_FIELDS = {
    name: {
      label: t("settings.invite_members.details_tab.member_details.name"),
      type: "string",
    },
    email: {
      label: t("settings.invite_members.details_tab.member_details.email"),
      type: "string",
    },
  };

  return (
    <PreviewCardLayout
      title={t("help_widget.copilot.preview_cards.member_card_title")}
      url={url}
    >
      <ul className="flex flex-col leading-5">
        {Object.entries(MEMBER_FIELDS).map(
          ([key, keyProps]) =>
            params[key] && (
              <li key={key} className="!pb-0">
                <Typography.BodySm color="text-dark">
                  <strong>{keyProps.label}:</strong>{" "}
                  {getFormattedValue(params[key], keyProps.type)}
                </Typography.BodySm>
              </li>
            ),
        )}
      </ul>
    </PreviewCardLayout>
  );
};
